/** Frontend-authored UI copy. Keys are the English source strings. Game and provider names are not listed. */
export const BN_PHRASES = {
  HOT: 'হট',
  'HOT!': 'হট!',
  SPORTS: 'স্পোর্টস',
  CASINO: 'ক্যাসিনো',
  SLOTS: 'স্লটস',
  CRASH: 'ক্র্যাশ',
  TABLE: 'টেবিল',
  FISHING: 'ফিশিং',
  ARCADE: 'আর্কেড',
  LOTTERY: 'লটারি',
  Home: 'হোম',
  Games: 'গেমস',
  Promotions: 'প্রমোশন',
  Promotion: 'প্রমোশন',
  Deposit: 'ডিপোজিট',
  Withdrawal: 'উইথড্র',
  Profile: 'প্রোফাইল',
  Login: 'লগইন',
  'Sign up': 'সাইন আপ',
  'Sign Up': 'সাইন আপ',
  App: 'অ্যাপ',
  Menu: 'মেনু',
  'Live Chat': 'লাইভ চ্যাট',
  'View all': 'সব দেখুন',
  'Loading promotions…': 'প্রমোশন লোড হচ্ছে…',
  'Promotions unavailable right now.': 'এই মুহূর্তে প্রমোশন পাওয়া যাচ্ছে না।',
  'No promotions available.': 'কোনো প্রমোশন নেই।',
  Favourites: 'পছন্দের',
  Favourite: 'পছন্দের',
  'Recent Play': 'সাম্প্রতিক খেলা',
  Game: 'গেম',
  Close: 'বন্ধ',
  Download: 'ডাউনলোড',
  'Desktop navigation': 'ডেস্কটপ মেনু',
  'Winner Board': 'উইনার বোর্ড',
  'VIP Program': 'ভিআইপি প্রোগ্রাম',
  Referral: 'রেফারেল',
  'Contact Us': 'যোগাযোগ',
  'About Us': 'আমাদের সম্পর্কে',
  'Privacy Policy': 'গোপনীয়তা নীতি',
  'Terms & Conditions': 'শর্তাবলি',
  'Rules and Regulations': 'নিয়মকানুন',
  'Responsible Gaming': 'দায়িত্বশীল গেমিং',
  'Frequently Asked Questions': 'সাধারণ প্রশ্ন',
  Affiliate: 'অ্যাফিলিয়েট',
  'Best Quality Platform': 'সেরা মানের প্ল্যাটফর্ম',
  '© 2026 9Baji Copyrights. All Rights Reserved': '© 2026 9Baji কপিরাইট। সর্বস্বত্ব সংরক্ষিত',
  'The Perfect Spot for Cricket Betting and Casino Site in Bangladesh':
    'বাংলাদেশে ক্রিকেট বেটিং ও ক্যাসিনোর সেরা ঠিকানা',
  'No Banner': 'কোনো ব্যানার নেই',
  Banner: 'ব্যানার',
  'Login banner': 'লগইন ব্যানার',
  'Sign up banner': 'সাইন আপ ব্যানার',
  'Login Successful': 'লগইন সফল হয়েছে',
  'Logout Successful': 'লগআউট সফল হয়েছে',
  'Switch to Bengali': 'বাংলায় যান',
  'Switch to English': 'ইংরেজিতে যান',
  'Between 6~20 characters.': '৬ থেকে ২০ অক্ষর।',
  'At least one alphabet.': 'কমপক্ষে একটি অক্ষর।',
  'At least one number. (Special character, symbols are allowed)':
    'কমপক্ষে একটি সংখ্যা। (বিশেষ চিহ্ন ব্যবহার করা যাবে)',
  'Password requirements': 'পাসওয়ার্ডের শর্ত',
  'Hide password': 'পাসওয়ার্ড লুকান',
  'Show password': 'পাসওয়ার্ড দেখান',
  '6-20 characters and numbers': '৬-২০ অক্ষর ও সংখ্যা',
  'Loading…': 'লোড হচ্ছে…',
  'Loading history…': 'ইতিহাস লোড হচ্ছে…',
  'No history found.': 'কোনো ইতিহাস পাওয়া যায়নি।',
  'Date/Time': 'তারিখ/সময়',
  Type: 'ধরন',
  Category: 'ক্যাটাগরি',
  'No Data': 'কোনো তথ্য নেই',
  'Result': 'ফলাফল',
  'Page': 'পৃষ্ঠা',
  'Loading…': 'লোড হচ্ছে…',
  'Bet / Reference ID': 'বেট / রেফারেন্স আইডি',
  'Profit / Loss': 'লাভ / ক্ষতি',
  'Stake / Bet': 'স্টেক / বেট',
  'Betting Records requires React hooks.': 'Betting Records requires React hooks.',
  'Game Name': 'গেমের নাম',
  'Provider / Source': 'প্রোভাইডার / সোর্স',
  'Bet Amount': 'বেটের পরিমাণ',
  'Win Amount': 'জয়ের পরিমাণ',
  'Loss Amount': 'হারের পরিমাণ',
  'Refund Amount': 'রিফান্ডের পরিমাণ',
  'Net Result': 'নিট ফল',
  'Balance Before': 'আগের ব্যালেন্স',
  'Balance After': 'পরের ব্যালেন্স',
  Status: 'স্ট্যাটাস',
  'Reference / Transaction ID': 'রেফারেন্স / ট্রানজ্যাকশন আইডি',
  'Date from': 'শুরুর তারিখ',
  'Date to': 'শেষ তারিখ',
  All: 'সব',
  'All Providers / Sources': 'সব প্রোভাইডার / সোর্স',
  Result: 'ফলাফল',
  Search: 'খুঁজুন',
  'Reference, game code, method': 'রেফারেন্স, গেম কোড, মেথড',
  History: 'ইতিহাস',
  Transactions: 'লেনদেন',
  '9Wicket Bets': '9Wicket বেট',
  Previous: 'আগের',
  Next: 'পরের',
  Page: 'পৃষ্ঠা',
  of: 'এর',
  Back: 'পিছনে',
  Confirm: 'নিশ্চিত করুন',
  Retry: 'আবার চেষ্টা',
  Date: 'তারিখ',
  Today: 'আজ',
  Yesterday: 'গতকাল',
  'Last 7 days': 'গত ৭ দিন',
  Settled: 'নিষ্পত্তি হয়েছে',
  Unsettled: 'নিষ্পত্তি হয়নি',
  Platform: 'প্ল্যাটফর্ম',
  'Game Type': 'গেমের ধরন',
  Turnover: 'টার্নওভার',
  'Betting Records': 'বেটিং রেকর্ড',
  'Betting Record Filter': 'বেটিং রেকর্ড ফিল্টার',
  'Transaction Records': 'লেনদেনের রেকর্ড',
  'Transaction Records Filter': 'লেনদেন ফিল্টার',
  Amount: 'পরিমাণ',
  'Txn Date': 'লেনদেনের তারিখ',
  'Payment Type': 'পেমেন্টের ধরন',
  Processing: 'প্রসেস হচ্ছে',
  Rejected: 'বাতিল',
  Approved: 'অনুমোদিত',
  Adjustment: 'অ্যাডজাস্টমেন্ট',
  'Payment Method': 'পেমেন্ট মেথড',
  'Request Status': 'রিকোয়েস্টের অবস্থা',
  Note: 'নোট',
  Reference: 'রেফারেন্স',
  COMPLETED: 'সম্পন্ন',
  ACTIVE: 'সক্রিয়',
  'Failed to load': 'লোড করা যায়নি',
  'Session expired. Please log in again.': 'সেশনের মেয়াদ শেষ। আবার লগইন করুন।',
  'Game failed to load. Please try again.': 'গেম লোড হয়নি। আবার চেষ্টা করুন।',
  'Deposit UI Error': 'ডিপোজিট পেজে সমস্যা',
  'Unknown error': 'অজানা সমস্যা',
  'Please complete your turnover.': 'আগে টার্নওভার পূরণ করুন।',
  'Close turnover notice': 'টার্নওভার নোটিশ বন্ধ করুন',
  'Withdrawal Request Submitted Successfully!': 'উইথড্র রিকোয়েস্ট সফলভাবে জমা হয়েছে!',
  'NMX Pay is temporarily unavailable. Please try again later.':
    'NMX Pay এই মুহূর্তে পাওয়া যাচ্ছে না। পরে আবার চেষ্টা করুন।',
  'Select a receiving account': 'রিসিভিং অ্যাকাউন্ট বেছে নিন',
  'Customer Support': 'কাস্টমার সাপোর্ট',
  'Tawk.to Support': 'Tawk.to সাপোর্ট',
  'Messenger Support': 'Messenger সাপোর্ট',
  'Telegram Support': 'Telegram সাপোর্ট',
  'WhatsApp Support': 'WhatsApp সাপোর্ট',
  Support: 'সাপোর্ট',
  'Full Name': 'পুরো নাম',
  Birthday: 'জন্মদিন',
  'Phone Number': 'ফোন নম্বর',
  Email: 'ইমেইল',
  'Date Registered': 'রেজিস্ট্রেশনের তারিখ',
  'VIP Points (VP)': 'ভিআইপি পয়েন্ট (VP)',
  'My VIP': 'আমার ভিআইপি',
  Default: 'ডিফল্ট',
  Verified: 'ভেরিফাইড',
  'Not Verified': 'ভেরিফাই হয়নি',
  Add: 'যোগ করুন',
  'Add Full Name': 'পুরো নাম যোগ করুন',
  'Add Birthday': 'জন্মদিন যোগ করুন',
  'Add E-mail': 'ইমেইল যোগ করুন',
  'Add Phone Number': 'ফোন নম্বর যোগ করুন',
  'Verify Phone Number': 'ফোন নম্বর যাচাই করুন',
  'Your full name ...': 'আপনার পুরো নাম ...',
  'Enter your E-mail.': 'ইমেইল লিখুন।',
  'Enter your phone number.': 'ফোন নম্বর লিখুন।',
  '11 digit phone number': '১১ সংখ্যার ফোন নম্বর',
  Cancel: 'বাতিল',
  Verify: 'যাচাই',
  Change: 'পরিবর্তন',
  'Please input verification code': 'ভেরিফিকেশন কোড দিন',
  Resend: 'আবার পাঠান',
  'Verify your primary phone before adding another number.':
    'আরেকটি নম্বর যোগ করার আগে মূল ফোন নম্বর যাচাই করুন।',
  'Confirm your primary phone with OTP before adding another number.':
    'আরেকটি নম্বর যোগ করতে মূল ফোনে OTP দিয়ে নিশ্চিত করুন।',
  'Maximum 2 allowed.': 'সর্বোচ্চ ২টি যোগ করা যাবে।',
  'Code expired. Request a new one.': 'কোডের মেয়াদ শেষ। নতুন কোড নিন।',
  'Incorrect code.': 'কোডটি ভুল।',
  'Cannot be changed': 'পরিবর্তন করা যাবে না',
  'Not Set': 'দেওয়া হয়নি',
  'Email save will be linked when the email API is available.':
    'ইমেইল সংরক্ষণ ইমেইল সেবা চালু হলে যুক্ত হবে।',
  'For privacy and security, Information can’t modified after confirmation. Please contact customer service .':
    'গোপনীয়তা ও নিরাপত্তার জন্য নিশ্চিত করার পর তথ্য বদলানো যায় না। কাস্টমার সার্ভিসে যোগাযোগ করুন।',
  'Personal Info': 'ব্যক্তিগত তথ্য',
  'Enter an amount greater than 0': '০-এর বেশি একটি পরিমাণ লিখুন',
  'Transferred to Main Wallet': 'মেইন ওয়ালেটে স্থানান্তর হয়েছে',
  'Transfer failed': 'স্থানান্তর হয়নি',
  'Commission Rate': 'কমিশন হার',
  'Commission Balance': 'কমিশন ব্যালেন্স',
  'Transfer to Main Wallet': 'মেইন ওয়ালেটে স্থানান্তর',
  Transfer: 'স্থানান্তর',
  'Deposit Bonus': 'ডিপোজিট বোনাস',
  'New User Bonus': 'নতুন ইউজার বোনাস',
  'Referral Bonus': 'রেফারেল বোনাস',
  'Referral Commission': 'রেফারেল কমিশন',
  'Cashback Bonus': 'ক্যাশব্যাক বোনাস',
  'Reload Bonus': 'রিলোড বোনাস',
  'Free Spin': 'ফ্রি স্পিন',
  'Event Promotion': 'ইভেন্ট প্রমোশন',
  'First Deposit Bonus': 'প্রথম ডিপোজিট বোনাস',
  'Second Deposit Bonus': 'দ্বিতীয় ডিপোজিট বোনাস',
  'Third Deposit Bonus': 'তৃতীয় ডিপোজিট বোনাস',
  'Fourth Deposit Bonus': 'চতুর্থ ডিপোজিট বোনাস',
  'Fifth Deposit Bonus': 'পঞ্চম ডিপোজিট বোনাস',
  'Daily Bonus': 'দৈনিক বোনাস',
  'Weekly Bonus': 'সাপ্তাহিক বোনাস',
  'Affiliate Deposit': 'অ্যাফিলিয়েট ডিপোজিট',
  'Affiliate Commission': 'অ্যাফিলিয়েট কমিশন',
  Information: 'তথ্য',
  'Back to home': 'হোমে ফিরুন',
  '← Home': '← হোম',
  'Here are some common questions and answers about 9Baji.':
    '9Baji নিয়ে কিছু সাধারণ প্রশ্ন ও উত্তর এখানে আছে।',
  'If you cannot find your question in the list below, please contact our customer support through Live Chat.':
    'নিচের তালিকায় প্রশ্ন না পেলে লাইভ চ্যাটের মাধ্যমে কাস্টমার সাপোর্টে যোগাযোগ করুন।',
  'Search your questions here...': 'এখানে আপনার প্রশ্ন খুঁজুন...',
  'Search FAQs': 'প্রশ্ন খুঁজুন',
  'Explore Help Topics': 'সহায়তার বিষয় দেখুন',
  'No matching questions found.': 'মিলে এমন কোনো প্রশ্ন নেই।',
  Account: 'অ্যাকাউন্ট',
  Casino: 'ক্যাসিনো',
  Lottery: 'লটারি',
  Payment: 'পেমেন্ট',
  Table: 'টেবিল',
  Security: 'নিরাপত্তা',
  Slots: 'স্লটস',
  Sports: 'স্পোর্টস',
  'Live Chat: Available on the 9Baji website for quick help.':
    'লাইভ চ্যাট: দ্রুত সাহায্যের জন্য 9Baji ওয়েবসাইটে পাওয়া যাচ্ছে।',
  'Additional contact channels will appear here when officially published for 9Baji.':
    'অতিরিক্ত যোগাযোগের মাধ্যম 9Baji আনুষ্ঠানিকভাবে প্রকাশ করলে এখানে দেখা যাবে।',
  'Open Live Chat': 'লাইভ চ্যাট খুলুন',
  'Telegram: ': 'Telegram: ',
  'Referral Tools': 'রেফারেল টুল',
  'Content is not available yet.': 'এই বিষয়ের লেখা এখনো যোগ করা হয়নি।',
  'Game Wallet Transfer': 'গেম ওয়ালেট স্থানান্তর',
  Refund: 'রিফান্ড',
  'Game Bet': 'গেম বেট',
  'Game Win': 'গেম জয়',
  Pending: 'অপেক্ষমাণ',
  Failed: 'ব্যর্থ',
  Success: 'সফল',
  Copied: 'কপি হয়েছে',
  Copy: 'কপি',
  '✓ Copied': '✓ কপি হয়েছে',
  'Normal / Member': 'সাধারণ / মেম্বার',
  'Guest User': 'অতিথি ইউজার',
  'Allow pop-ups to open 9Wicket.': '9Wicket খুলতে পপ-আপের অনুমতি দিন।',
  'Launch URL not received.': 'গেম খোলার লিংক পাওয়া যায়নি।',
  'Request failed.': 'রিকোয়েস্ট ব্যর্থ হয়েছে।',
  'No refresh token.': 'রিফ্রেশ টোকেন নেই।',
  hot: 'হট',
  sports: 'স্পোর্টস',
  casino: 'ক্যাসিনো',
  slots: 'স্লটস',
  crash: 'ক্র্যাশ',
  table: 'টেবিল',
  fishing: 'ফিশিং',
  arcade: 'আর্কেড',
  lottery: 'লটারি',
  'Log in': 'লগ ইন',
  Username: 'ইউজারনেম',
  Funds: 'ফান্ড',
  'My Promotion': 'আমার প্রমোশন',
  'No payment methods': 'কোনো পেমেন্ট পদ্ধতি নেই',
  'Send To': 'পাঠানোর নম্বর',
  'Please verify your phone number': 'ফোন নম্বর যাচাই করুন',
  'No 9Wicket betting records found.': 'কোনো 9Wicket বেটিং রেকর্ড পাওয়া যায়নি।',
  'Date / Time': 'তারিখ / সময়',
  'Category / Game Type': 'ক্যাটাগরি / গেমের ধরন',
  'Game / Event Name': 'গেম / ইভেন্টের নাম',
  'Win/Loss Amount': 'জিত/হারের পরিমাণ',
  'Valid Bet': 'ভ্যালিড বেট',
  'Settlement Status': 'সেটেলমেন্ট স্ট্যাটাস',
  'Reference / Bet ID': 'রেফারেন্স / বেট আইডি',
  'Loading 9Wicket bets…': '9Wicket বেট লোড হচ্ছে…',
  '4-16 char, allow number': '৪-১৬ অক্ষর, সংখ্যা চলবে',
  'Enter your phone number.': 'ফোন নম্বর লিখুন।',
  'Event, game type, bet ID': 'ইভেন্ট, গেমের ধরন, বেট আইডি',
  'Failed to load ': 'লোড হয়নি ',
  'Deposit UI Error': 'ডিপোজিট ইন্টারফেস ত্রুটি',
  'Withdraw UI Error': 'উইথড্র ইন্টারফেস ত্রুটি',
  'Unknown error': 'অজানা ত্রুটি',
};

export const KEYED_PHRASES = {
  en: {
    affTransferInvalid: 'Enter an amount greater than 0',
    affTransferSuccess: 'Transferred to Main Wallet',
    affTransferFailed: 'Transfer failed',
    affCommissionRate: 'Commission Rate',
    affCommissionBalance: 'Commission Balance',
    affTransferAmount: 'Amount',
    affTransferBtn: 'Transfer',
    turnoverNotice: 'Please complete your turnover.',
    turnoverNoticeClose: 'Close turnover notice',
    withdrawSuccessPopup: 'Withdrawal Request Submitted Successfully!',
    nmxUnavailable: 'NMX Pay is temporarily unavailable. Please try again later.',
  },
  bn: {
    affTransferInvalid: '০-এর বেশি একটি পরিমাণ লিখুন',
    affTransferSuccess: 'মেইন ওয়ালেটে স্থানান্তর হয়েছে',
    affTransferFailed: 'স্থানান্তর হয়নি',
    affCommissionRate: 'কমিশন হার',
    affCommissionBalance: 'কমিশন ব্যালেন্স',
    affTransferAmount: 'পরিমাণ',
    affTransferBtn: 'স্থানান্তর',
    turnoverNotice: 'আগে টার্নওভার পূরণ করুন।',
    turnoverNoticeClose: 'টার্নওভার নোটিশ বন্ধ করুন',
    withdrawSuccessPopup: 'উইথড্র রিকোয়েস্ট সফলভাবে জমা হয়েছে!',
    nmxUnavailable: 'NMX Pay এই মুহূর্তে পাওয়া যাচ্ছে না। পরে আবার চেষ্টা করুন।',
  },
};
